// extracted by mini-css-extract-plugin
module.exports = {"box":"styles_box__1f7Mq","check":"styles_check__2-2Uq","T":"styles_T__2m8ZP","F":"styles_F__2v71K","question":"styles_question__1YEws"};